import React from "react";
import { Tooltip, type TooltipProps, List, ListItem, Box } from "@mui/material";
import { Typography } from "@platform/design-system";

type CustomTooltipProps = {
  title: string;
  items: string[];
  children: React.ReactElement;
  placement?: TooltipProps["placement"];
};

export const CustomTooltip = ({
  title,
  items,
  children,
  placement = "bottom-start",
}: CustomTooltipProps): React.JSX.Element => {
  const tooltipContent = (
    <>
      <Typography variant="body-medium" display="block" mb={0.5}>
        <strong>{title}</strong>
      </Typography>
      <List dense disablePadding>
        {items.map((item) => (
          <ListItem key={item} disablePadding sx={{ py: 0.25, px: 1 }}>
            <Typography variant="body-medium" color="textSecondary">
              • {item}
            </Typography>
          </ListItem>
        ))}
      </List>
    </>
  );

  const slotProps: TooltipProps["slotProps"] = {
    tooltip: {
      sx: {
        bgcolor: "background.paper",
        color: "text.primary",
        border: "1px solid",
        borderColor: "divider",
        p: 1.5,
        minWidth: 140,
        borderRadius: 1.5,
      },
    },
    arrow: {
      sx: { color: "background.paper" },
    },
  };

  return (
    <Tooltip title={tooltipContent} placement={placement} slotProps={slotProps}>
      <Box sx={{ cursor: "pointer", display: "inline-flex" }}>{children}</Box>
    </Tooltip>
  );
};
